import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { Apiservice } from '../../services/api.service';
import { UtilityService } from '../../services/utility.service';
import { NgxSpinnerService } from 'ngx-spinner';
import notify from 'devextreme/ui/notify';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { NewNicaFormComponent } from '../nica-form/new-nica-form.component';

@Component({
  selector: 'app-allinea-registro-rentri',
  templateUrl: './allinea-registro-rentri.component.html',
  styleUrls: ['./allinea-registro-rentri.component.css']
})
export class AllineaRegistroRentriComponent implements OnInit {
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent
  @Input() guid: string
  @Input() selezionaRegistro: boolean = true
  @Input() isEdit: boolean = true
  @Input() dataJsonRelated: { [key: string]: any }
  @Output() emittedData: EventEmitter<any> = new EventEmitter<any>()
  filterGrid: string = ''
  queryStringForm: string = ''
  filterKeyForm: string = ''
  apiForm: string = 'rentri/registri'
  apiGrid: string = 'rentri/registri'
  listaRS: { [key: string]: any }[]
  listaAttivitaSoggetto: string[] = []
  listaAttivitaRSSoggetto: string[] = []
  CustomButtonSetForm = [
    {
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'after',
      stylingMode: 'contains',
      text: 'Ritorna',
      icon: 'icon-annulla-form ',
      hint: 'Ritorna',
      visible: true,
      disabled: false,
      id: 'return'
    }
  ]
  private idRegistroRentri: string
  constructor(private componentService: ComponentService, private apiService: Apiservice, private cdr: ChangeDetectorRef, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    console.log(this.listaAttivitaSoggetto)
    console.log(this.listaAttivitaRSSoggetto)
    if (this.dataJsonRelated) {
      this.idRegistroRentri = this.dataJsonRelated.registroRentri !== null ? this.dataJsonRelated.registroRentri : 'Da Creare'
      this.filterGrid = `?idSoggetto=${this.dataJsonRelated.idSoggetto}&num_iscr_sito=${this.dataJsonRelated.idSedeRentri}&escludiAllineati=true`;
      this.queryStringForm = `?idSoggetto=${this.dataJsonRelated.idSoggetto}&num_iscr_sito=${this.dataJsonRelated.idSedeRentri}&includiDatiUltimaRegistrazione=true`
      if (this.isEdit) {
        this.queryStringForm = `/${this.dataJsonRelated.registroRentri}?idSoggetto=${this.dataJsonRelated.idSoggetto}&num_iscr_sito=${this.dataJsonRelated.idSedeRentri}&includiDatiUltimaRegistrazione=true`
      }

    }
  }

  formInitRegistro(event) {
    console.log(event)
    if (event.name === "formContentInitializzed") {
      event.formData['unitaLocale'] = this.dataJsonRelated.sede_Descrizione
      event.formData['num_iscr_sito'] = this.dataJsonRelated.idSedeRentri
      event.formData['registroRentri'] = this.idRegistroRentri
      event.formData['descrizione'] = this.dataJsonRelated.descrizione

      if (this.dataJsonRelated.ultimo_progressivo) event.formData['ultimo_progressivo'] = this.dataJsonRelated.ultimo_progressivo.toString().padStart(6, '0')
      if (this.dataJsonRelated.data_ora_registrazione_ultimo_movimento) event.formData['data_ora_registrazione_ultimo_movimento'] = this.dataJsonRelated.data_ora_registrazione_ultimo_movimento
      if (event.component && event.component.elementRef) {
        const elementRef = event.component.elementRef
        const listaAttivita = elementRef.listaAttivita
        const listaRecupero = elementRef.listaRecupero
        const listaSmaltimento = elementRef.listaSmaltimento
        const attivita = event.component.dataSet['attivita'] as string[] || []
        if (!this.isEdit) {
          event.component.dataSet['attivita'] = this.listaAttivitaSoggetto
          event.component.dataSet['listaAttivita'] = this.listaAttivitaSoggetto
          event.component.dataSet['attivita_rec_smalt'] = this.listaAttivitaRSSoggetto
          event.component.dataSet['numero_movimenti'] = 0
          event.component.dataSet['ultimo_progressivo'] = '000000'
          event.component.dataSet['data_ora_registrazione_ultimo_movimento'] = null
        }
        if (listaAttivita) {
          listaAttivita.component.optionData = [
            { key: 'CentroRaccolta', value: 'Centro Raccolta' },
            { key: 'Produzione', value: 'Produzione' },
            { key: 'Recupero', value: 'Recupero' },
            { key: 'Smaltimento', value: 'Smaltimento' },
            { key: 'Trasporto', value: 'Trasporto' },
            { key: 'IntermediazioneSenzaDetenzione', value: 'Intermediazione Senza Detenzione' },
          ].map((item) => {
            if (this.isEdit) {
              item['disabled'] = true
              return item
            }
            if (!this.listaAttivitaSoggetto.some((value: string) => value === item.key)) {
              item['disabled'] = true
              return item
            }
            return item
          })
          listaAttivita.component.selectedObject = event.component.dataSet['attivita']
        }
        const attivita_rec_smalt = event.component.dataSet['attivita_rec_smalt']
        if (listaRecupero) {
          listaRecupero.component.optionData = this.listaRS.filter(item => item.code.includes('R')).map((item) => {
            if (!attivita.some((item) => item === 'Recupero')) {
              item['disabled'] = true
            }
            if (!this.listaAttivitaRSSoggetto.includes(item.code)) {
              item['disabled'] = true;
            }
            return item
          })
          if (attivita_rec_smalt && attivita_rec_smalt !== null) {
            listaRecupero.component.selectedObject = attivita_rec_smalt.filter(item => item.includes('R'))
          }
        }
        if (listaSmaltimento) {
          listaSmaltimento.component.optionData = this.listaRS.filter(item => item.code.includes('D')).map((item) => {
            if (!attivita.some((item) => item === 'Smaltimento')) {
              item['disabled'] = true
            }
            if (!this.listaAttivitaRSSoggetto.includes(item.code)) {
              item['disabled'] = true;
            }
            return item
          })
          if (attivita_rec_smalt && attivita_rec_smalt !== null) {
            listaSmaltimento.component.selectedObject = attivita_rec_smalt.filter(item => item.includes('D'))
          }
        }
      }
    }
    event.component.formRefreshInputData('ultimo_progressivo', event.component.dataSet['ultimo_progressivo'].toString().padStart(6, '0'))

    this.cdr.detectChanges()
  }
  formEventRegistro(event) {
    console.log(event)
    if (event.name === "return") {
      if (this.formAnagrafica) {
        if (Object.keys(this.formAnagrafica.allDataChanged).length > 0) {
          confirm("Desideri salvare le modifiche? ", "Attenzione!").then(val => {
            if (val) {
              this.salvaRegistro(this.formAnagrafica.dataSet)
            }
            this.componentService.destroyCurrentOpenPopUpByGuid(this.guid)
          })
        }
      }
    }
    if (event.name === "beforSave") {
      event.cancella = true
      const data = event.formData
      this.salvaRegistro(data)
    }
    this.cdr.detectChanges()

  }
  formItemsEventRegistro(event) {
    console.log(event)
    if (event.name === "onValueChanged") {
      const newNica = event.masterComponent
      const dataField = event.campo.dataField
      const elementRef = newNica.elementRef
      if (newNica && dataField) {
        switch (dataField) {
          case 'listaRecupero':
          case 'listaSmaltimento':
            if (newNica.dataSet['attivita_rec_smalt'] === null || newNica.dataSet['attivita_rec_smalt'] === undefined) {
              newNica.dataSet['attivita_rec_smalt'] = []
            }
            const nuovaParteR = [...new Set(newNica.dataSet['listaRecupero'])];
            const nuovaParteD = [...new Set(newNica.dataSet['listaSmaltimento'])];
            newNica.dataSet['attivita_rec_smalt'] = [...nuovaParteR, ...nuovaParteD];
            break;
          case 'listaAttivita':
            if (!newNica.dataSet['listaAttivita'].includes('Recupero')) {
              newNica.dataSet['listaRecupero'] = []
              if (elementRef) elementRef.listaRecupero.component.selectedObject = []
            } else {
              newNica.dataSet['listaRecupero'] = this.listaAttivitaRSSoggetto.filter(item => item.includes('R'))
              if (elementRef) elementRef.listaRecupero.component.selectedObject = this.listaAttivitaRSSoggetto.filter(item => item.includes('R'))
            }
            newNica.elementRef.listaRecupero.component.optionData = newNica.elementRef.listaRecupero.component.optionData.map((item) => {
              item['disabled'] = !this.listaAttivitaRSSoggetto.includes(item.code);
              if (!newNica.dataSet['listaAttivita'].includes('Recupero')) {
                item['disabled'] = true;
              }
              return item
            })
            if (!newNica.dataSet['listaAttivita'].includes('Smaltimento')) {
              newNica.dataSet['listaSmaltimento'] = []
              if (elementRef) elementRef.listaSmaltimento.component.selectedObject = []
            } else {
              newNica.dataSet['listaSmaltimento'] = this.listaAttivitaRSSoggetto.filter(item => item.includes('D'))
              if (elementRef) elementRef.listaSmaltimento.component.selectedObject = this.listaAttivitaRSSoggetto.filter(item => item.includes('D'))
            }
            newNica.elementRef.listaSmaltimento.component.optionData = newNica.elementRef.listaSmaltimento.component.optionData.map((item) => {
              item['disabled'] = !this.listaAttivitaRSSoggetto.includes(item.code);
              if (!newNica.dataSet['listaAttivita'].includes('Smaltimento')) {
                item['disabled'] = true;
              }
              return item

            })
            break;
          default:
            break;
        }
      }
    }
    this.cdr.detectChanges()

  }

  onAllEventGrid(event) {
    if (event.name === "onCellPrepared") {
      console.log(event)
      if (event.rowType === 'data' && event.data.numero_movimenti > 0) this.nicaAnagrafica.nascondiElementiRowByClasse('chiudiRegistro', event.rowIndex)
    }
    if (event.name === "onInitNewRow") {
      event.cancel = true
      this.isEdit = false;
      this.selezionaRegistro = false
    }

    this.cdr.detectChanges()

  }
  optionalButtonGrid(event) {
    console.log(event)
    if (event.name === "selezionaRegistro") {
      this.idRegistroRentri = event.row.data.identificativo
      this.isEdit = true;
      this.selezionaRegistro = false
      this.queryStringForm = `/${this.idRegistroRentri}?idSoggetto=${this.dataJsonRelated.idSoggetto}&num_iscr_sito=${this.dataJsonRelated.idSedeRentri}&includiDatiUltimaRegistrazione=true`

    }
    if (event.name === "chiudiRegistro") {
      const key = event.row.key
      const component = event.component
      if (!key || !component) {
        notify({
          message: "Errore nell'eliminazione del registro!",
          height: 45,
          width: 250,
          position: 'center center'
        }, 'error', 4000);
        return
      }
      confirm('Sei sicuro di vole chiudere il registro', 'Attenzione').then((res) => {
        if (!res) return
        this.spinner.show()
        this.apiService.DeleteApi(`${this.apiGrid}/${key}?idSoggetto=${this.dataJsonRelated.idSoggetto}`).then((res) => {
          this.spinner.hide()
          component.refresh()
          notify({
            message: 'Registro eliminato con successo!',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'success', 4000);
        }).catch((err) => {
          this.spinner.hide()
          notify({
            message: "Errore nell'eliminazione del registro!",
            height: 45,
            width: 250,
            position: 'center center'
          }, 'error', 4000);
        })
      })
    }
    this.cdr.detectChanges()

  }
  optionalBottoneToolbarGrid(event) {
    console.log(event)
  }

  private salvaRegistro(data) {
    if (this.isEdit) {
      this.apiService.PutApi(`${this.apiForm}${this.filterKeyForm}${this.queryStringForm}`, data).then((res) => {
        console.log(res)
        this.emittedData.emit({ data: {...res,...data}, event: 'saved' })
        notify({
          message: 'Registro modificato',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'success', 4000);
      }).catch((err) => {
        notify({
          message: 'Registro non modificato',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'danger', 4000);
      })
    } else {
      this.apiService.PostApi(`${this.apiForm}${this.queryStringForm}`, data).then((res) => {
        console.log(res)
        this.emittedData.emit({ data: {...res,...data}, event: 'saved' })
        notify({
          message: 'Registro creato',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'success', 4000);
      }).catch((err) => {
        notify({
          message: 'Registro non creato',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'danger', 4000);
      })
    }
  }
}
